export enum UserAttributeIdentifierEnum {
  CCP = 'CCP',
  RiskTechData = 'RISKTECHDATA',
  USER = 'USER'
}

export enum UserAttributeKeyEnum {
  PlatformApps = 'PLATFORM_APPS',
  isExternal = 'IsExternal',
  Applications = 'Applications'
}
